<template>
  <div
    id="app"
    class="b tb"
    v-if="show_app && Htmlloading"
    :style="{
      '--ThemeColor': '#EC1111',
      '--ThemeColor-rgb': '236,17,17'
    }"
  >
    <div v-if="$route.meta.is_switch_token != true">
      <header class="app-header" v-if="!$route.meta.hideHeader">
        <div class="content">
          <AppHeader />
        </div>
      </header>
      <section
        class=" flex"
        v-if="$route.path !== '/login' && $route.meta.alone != true"
        :class="hasContent ? 'app-content' : 'no-content'"
      >
        <!-- <Breadcrumb
          style="padding-top:20px;padding-bottom:20px;"
          v-if="breadcrumbItem && breadcrumbItem.length && this.showBread"
        >
          <BreadcrumbItem
            v-for="item in breadcrumbItem"
            :to="item.fullPath"
            :key="item.fullPath"
            class="BreadcrumbItem"
            ><span @click="watchBread(item)">{{
              item.meta && item.meta.title
            }}</span></BreadcrumbItem
          >
        </Breadcrumb> -->
        <!-- <Breadcrumb
          style="padding-top:20px;padding-bottom:20px;"
          v-if="bread && bread.length && this.showBread"
        >
          <BreadcrumbItem
            v-for="item in bread"
            :to="item.fullPath"
            :key="item.fullPath"
            class="BreadcrumbItem"
            ><span @click="watchBread(item)">{{
              item.meta && item.meta.title
            }}</span></BreadcrumbItem
          >
        </Breadcrumb> -->
        <Bread v-if="this.showBread" :current-mode="breadCurrentMode"></Bread>
        <keep-alive>
          <router-view exact v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view exact v-if="!$route.meta.keepAlive"></router-view>
      </section>

      <section v-if="$route.path == '/login'" class="loginSection">
        <router-view exact v-if="!$route.meta.keepAlive"></router-view>
      </section>

      <section v-if="$route.meta.alone == true">
        <router-view exact v-if="!$route.meta.keepAlive"></router-view>
      </section>

      <footer class="app-footer" v-if="$route.path !== '/login'">
        <div class="content">
          <AppFooter />
        </div>
      </footer>
    </div>
    <section v-if="$route.meta.is_switch_token == true" class="loginSection">
      <router-view exact v-if="!$route.meta.keepAlive"></router-view>
    </section>
    <!-- 全局 loading：命中 config/index.js 的 whiteListForLoading 的请求会打开它。
         注意必须把 loading 传给组件 —— Loading.vue 的根节点是 v-if="loading"（按 prop 决定渲染），
         原来只写了 v-if="isLoading"、没传 prop，所以组件被创建了却什么也不渲染 -->
    <loading v-if="isLoading" :loading="isLoading" />
    <pop-festival v-if="$route.meta.is_festivalPop" :pData="festivalData" />
    <Modal
      v-model="showConfirmDialog"
      :mask="true"
      :mask-closable="false"
      title="请确认卡信息"
      :loading="confirmBtnLoading"
      @on-ok="onConfirm"
      @on-cancel="cancel"
    >
      <template v-if="confirmDialog && confirmDialog.length > 0">
        <div class="dialogBox">
          <div
            v-for="(item, index) in confirmDialog"
            :key="index"
            :class="{ marginTop: index !== 0 }"
          >
            <div class="title b pc tb ac">
              <p class="b pc">{{ item.title }}</p>
              <p class="title-text b pc" v-text="index + 1"></p>
            </div>
            <div class="dialogList">
              <List size="small" style="margin: 20px 0;">
                <ListItem v-for="list in item.list" :key="list.key">
                  <Row style="width:100%">
                    <i-col span="10">{{ list.key }}</i-col>
                    <i-col span="14" style="text-align: right;">
                      {{ list.value }}
                    </i-col>
                  </Row>
                </ListItem>
              </List>
            </div>
            <div>
              <Divider
                style="margin: 20px 0;"
                orientation="left"
                v-if="item.channel_list && item.channel_list.length > 0"
                >适用专场与面额</Divider
              >
              <Table
                v-if="item.channel_list && item.channel_list.length > 0"
                :max-height="200"
                :columns="tableColumns"
                :data="item.channel_list"
              />
            </div>
          </div>
        </div>
      </template>
    </Modal>
    <Modal
      v-model="bindMobilePop"
      :mask="true"
      :mask-closable="false"
      :closable="false"
      title="绑定手机号"
    >
      <div class="b pc">
        <Form
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="80"
          style="width: 320px"
        >
          <FormItem label="手机号" prop="mobile">
            <PhoneInput
              size="large"
              v-model="formValidate.mobile"
              placeholder="请输入手机号"
            ></PhoneInput>
          </FormItem>
          <FormItem label="验证码" prop="verify_code">
            <InputWithBtn
              v-model="formValidate.verify_code"
              v-on:when-click="onsendCode"
              :disable="find_btnDisable"
              :loading="find_sendCodeLoading"
              :btn-text="find_btnText"
            />
          </FormItem>
        </Form>
      </div>
      <template #footer>
        <div class="b pc">
          <Button
            style="width: 100px"
            size="large"
            type="primary"
            @click="handleSubmit('formValidate')"
            >确认</Button
          >
        </div>
      </template>
    </Modal>
    <!-- 接口环境悬浮切换器：仅本地 / 测试宿主显示（正式域名下组件内部不渲染） -->
    <ApiEnvSwitch />
  </div>
</template>

<script>
import qs from 'qs';
import { mapState } from 'vuex';
import { saveChannelId, saveCustomId, showConfirm, showToast } from '@/common';
import AppFooter from '@/components/layout/Footer';
import AppHeader from '@/components/layout/Header';
import Bread from '@/components/layout/Bread';
import { hideBread, hideContent, breadCurrentMode } from '@/config';
import loading from '@/components/basics/Loading.vue';
import sessionStorage from '@/utils/storage/sessionStorage';
import PopFestival from './components/activity/popFestival.vue';
import ApiEnvSwitch from '@/components/basics/api-env-switch.vue';
import {
  cardReceiveList,
  card_receive,
  customConfig
} from './service/user/card';
import { tryCatch, is3mEnv } from './utils';
import { elementClick } from './utils/track/baidu_statistics';
import localStorage from './utils/storage/localStorage';
import { bindPhone, newUserCenter } from './service/user';
import { pwdVerify } from './service/common';
import InputWithBtn from '@/components/basics/InputWithBtn';

export default {
  name: 'App',
  data() {
    return {
      configData: '',
      showBread: true,
      hasContent: true,
      hideBreadList: hideBread,
      // 面包屑当前页那一格的显示方式（全局开关，见 config/index.js）
      breadCurrentMode,
      hideContentList: hideContent,
      show_app: false,
      Htmlloading: false,
      festivalData: null, //节日弹窗
      showConfirmDialog: false, //绑卡弹窗标识
      confirmBtnLoading: false,
      confirmDialog: null,
      card_receive_list_data: null,
      bindMobilePop: false,
      formValidate: {
        mobile: '',
        verify_code: ''
      },
      ruleValidate: {
        mobile: [{ required: true, message: '请填写手机号', trigger: 'blur' }],
        verify_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      find_btnText: '发送验证码',
      find_btnDisable: false,
      find_sendCodeLoading: false
    };
  },
  components: {
    AppFooter,
    AppHeader,
    Bread,
    loading,
    PopFestival,
    InputWithBtn,
    ApiEnvSwitch
  },
  created() {
    this.show_app = sessionStorage.get('show_app');
  },
  mounted() {
    let { channel_id, custom_id } =
      qs.parse(location.search.replace('?', '')) || {};
    saveChannelId(channel_id);
    saveCustomId(custom_id);
    this.init();
  },
  methods: {
    async init() {
      this.showBread = !this.hideBreadList.some(item => {
        return item == window.location.pathname;
      });
      this.hasContent = !this.hideContentList.some(item => {
        return item == window.location.pathname;
      });
      let nowdata = new Date();
      if (nowdata.getMonth() + 1 == 3 && nowdata.getDate() == 8) {
        this.handlePopQueue(
          'http://image.pandayoufu.com/wxstep/imgs/f4470120fae23bf8b844eb97fb69dbac.png'
        );
      } else {
        this.festivalData = null;
      }
      // 3m定制
      // 默认值
      this.showConfirmDialog = false;
      this.confirmDialog = null;
      this.card_receive_list_data = null;
      this.bindMobilePop = false;
      this.resetSendCodeTips();

      let session_info = localStorage.get('session_info');

      if (session_info && session_info.token) {
        if (is3mEnv()) {
          let customConfigRes = (await customConfig().catch(e => e)) || {};
          const { config } = customConfigRes;

          if (
            config &&
            config.user_get_card_alert &&
            config.user_get_card_alert.type
          ) {
            // 判断是否存在待领取卡券
            this.$Modal.info({
              title: '温馨提示',
              content: '您有待领取的福利，请前往领取',
              onOk: () => {
                cardReceiveList({ type: config.user_get_card_alert.type })
                  .then((cardRes = {}) => {
                    this.card_receive_list_data = cardRes;
                    const { cards } = cardRes;
                    if (cards && cards.length) {
                      this.confirmDialog = cards;
                    }
                    // 展示当前绑定卡券信息
                    this.showConfirmDialog = true;
                  })
                  .catch(() => {
                    this.showConfirmDialog = false;
                    showConfirm({
                      title: '温馨提示',
                      content: '福利卡券异常'
                    });
                  });
              }
            });
          } else {
            this.judgeBindMobile();
          }
        }
      }
    },
    async judgeBindMobile() {
      // 判断是否绑定手机号
      let centerInfo = (await newUserCenter().catch(e => e)) || {};
      if (centerInfo && !centerInfo.mobile) {
        this.bindMobilePop = true;
      } else if (centerInfo && !centerInfo.third_code) {
        localStorage.remove('session_info');
        window.location.href =
          '/login?redirect_url=' + encodeURIComponent(window.location.href);
      }
    },
    resetSendCodeTips() {
      this.btnText = this.find_btnText = '发送验证码';
      this.btnDisable = this.find_btnDisable = false;
      this.cutdownTimer && clearInterval(this.cutdownTimer);
      this.find_cutdownTimer && clearInterval(this.find_cutdownTimer);
    },
    // 发送找回密码验证码
    onsendCode() {
      if (!this.formValidate || !this.formValidate.mobile)
        return showToast({ message: '请填写手机号' }, 'error');
      this.find_sendCodeLoading = true;
      let params = {
        type: 1,
        mobile: this.formValidate.mobile
      };
      // 工号作为参数发送验证码
      pwdVerify(params)
        .then(() => {
          showToast({ message: '已发送，请注意查收' }, 'success');
          this.find_cutdownTimer && clearInterval(this.find_cutdownTimer);
          let count = 60;
          this.find_btnText = `60s后重新获取`;
          this.find_btnDisable = true;
          this.find_cutdownTimer = setInterval(() => {
            count -= 1;
            if (count > 0) {
              this.find_btnText = `${count}s后重新获取`;
            } else {
              this.find_btnText = '发送验证码';
              this.find_btnDisable = false;
              this.find_cutdownTimer && clearInterval(this.find_cutdownTimer);
            }
          }, 1000);
          this.find_sendCodeLoading = false;
        })
        .catch(() => {
          this.find_sendCodeLoading = false;
        });
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          bindPhone(this.formValidate).then(() => {
            showToast({ message: '绑定成功' }, 'success');
            this.bindMobilePop = false;
          });
        }
      });
    },
    onConfirm() {
      tryCatch(
        () => {
          this.confirmBtnLoading = true;
          let req = {
            bind_code: this.card_receive_list_data.bind_code
          };
          card_receive(req)
            .then(() => {
              this.$Message.success('绑定成功');
              this.confirmBtnLoading = false;
              this.cancel();
              elementClick('确认绑卡', 'success');
              // 绑卡成功后校验是否绑定手机号
              this.judgeBindMobile();
            })
            .catch(e => {
              e;
              this.confirmBtnLoading = false;
              this.cancel();
            });
        },
        () => {
          this.confirmBtnLoading = false;
        }
      );
    },
    cancel() {
      this.showConfirmDialog = false;
    },
    handlePopQueue(img) {
      let obj = {
        channel_id: '',
        custom_id: '',
        title: '温馨提示',
        img,
        text: '',
        closeText: '不再提示',
        confimText: '知道了'
      };
      this.festivalData = obj;
    }
  },
  computed: {
    ...mapState('common', ['breadcrumbItem', 'isLoading']),
    pageTitle() {
      if (this.breadcrumbItem && this.breadcrumbItem.length) {
        return this.breadcrumbItem[1].meta.title;
      }
      return '';
    }
  },
  watch: {
    $route() {
      if (this.$route) {
        this.Htmlloading = true;
      }
      this.init();
    }
  }
};
</script>

<style lang="scss">
html {
  overflow-y: auto;
}
body {
  overflow-y: auto;
}
html,
body {
  height: 100%;
}
#app {
  min-height: 100%;
  // width: 100%;
  min-width: 960px;
  background: $color-mainBackground;
  // overflow: hidden;
}
.ivu-notice {
  top: 50% !important;
  left: 50%;
  transform: translate(-50%, -50%);
}
/* ===== 弹框默认整体垂直居中 =====
   iView 的 Modal 默认是「距顶 100px」贴在页面上方（.ivu-modal { top: 100px }），
   这里统一改成垂直居中。用 margin: auto 而不是 align-items: center ——
   内容高于视口时 auto 外边距会退化成 0，弹框顶部仍然可达、能正常滚动查看。 */
.ivu-modal-wrap {
  display: flex;
  .ivu-modal {
    // 覆盖 iView 默认的 top: 100px；水平、垂直居中一起交给 auto 外边距
    top: 0;
    margin: auto;
  }
}
.ivu-breadcrumb {
  font-size: 16px;
}
.app-header {
  width: 100%;
  margin: auto;
  height: $app-header-height;
  min-width: 960px;
  background: #fff;
  .content {
    margin: auto;
  }
}
.app-content {
  width: 1150px;
  margin: auto;
  min-height: calc(100vh - 330px);
  min-width: 960px;
  /deep/ .ivu-breadcrumb-item-link {
    //面包屑导航字体样式
    font-size: 14px;
  }
}
.no-content {
  min-height: calc(100vh - 330px);
  min-width: 960px;
}

.loginSection {
  background: #fff;
  height: calc(100vh);
  min-height: calc(100vh);
}

.app-footer {
  width: 100%;
  margin: auto;
  height: $app-footer-height;
  min-width: 960px;
  background: #ffffff;
  .content {
    margin: auto;
    width: 1150px;
  }
}
.ivu-page-item-active {
  @include border_color($border-color);
  @include background_primary($background-color);
  a {
    color: #fff;
  }
}
.ivu-page-item:hover,
.iviewPage .ivu-page-next:hover,
.iviewPage .ivu-page-prev:hover {
  border-color: transparent;
  @include background_primary($background-color);
  a {
    color: #fff;
  }
}
[class*='my-hairline'] {
  position: relative;
}
[class*='my-hairline']::after {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  top: -50%;
  right: -50%;
  bottom: -50%;
  left: -50%;
  border: 0 solid #ddd;
  transform: scale(0.5);
}
.my-hairline--bottom::after {
  border-bottom-width: 1px;
}
.my-hairline--top::after {
  border-top-width: 1px;
}
.my-hairline--left::after {
  border-left-width: 1px;
}
.my-hairline--right::after {
  border-right-width: 1px;
}
// *::-webkit-scrollbar {
//     width: 0;
//     height: 0;
//     background: transparent;
// }
</style>
